/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ProductGallery = ({ images = [], alt = '' }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, align: 'start', dragFree: false });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const onSelect = useCallback((api) => {
    if (!api) return;
    setSelectedIndex(api.selectedScrollSnap());
    setCanPrev(api.canScrollPrev());
    setCanNext(api.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect(emblaApi);
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
    return () => {
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', onSelect);
    };
  }, [emblaApi, onSelect]);

  if (!images || images.length === 0) {
    return <div className="bg-[#e9e2d3] aspect-[4/5]" />;
  }

  const scrollTo = (idx) => emblaApi && emblaApi.scrollTo(idx);
  const scrollPrev = () => emblaApi && emblaApi.scrollPrev();
  const scrollNext = () => emblaApi && emblaApi.scrollNext();

  const single = images.length === 1;

  return (
    <div>
      <div className="relative">
        <div className="overflow-hidden bg-[#e9e2d3]" ref={emblaRef}>
          <div className="flex">
            {images.map((src, idx) => (
              <div key={idx} className="flex-[0_0_100%] min-w-0 aspect-[4/5]">
                <img src={src} alt={`${alt} – view ${idx + 1}`} className="w-full h-full object-cover select-none" draggable={false} />
              </div>
            ))}
          </div>
        </div>

        {!single && (
          <>
            <button
              type="button"
              onClick={scrollPrev}
              disabled={!canPrev}
              aria-label="Previous image"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-[#f5f1e6]/90 hover:bg-[#f5f1e6] border border-[#cdc2b1] flex items-center justify-center transition-opacity disabled:opacity-30"
            >
              <ChevronLeft className="w-5 h-5" strokeWidth={1.4} />
            </button>
            <button
              type="button"
              onClick={scrollNext}
              disabled={!canNext}
              aria-label="Next image"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-[#f5f1e6]/90 hover:bg-[#f5f1e6] border border-[#cdc2b1] flex items-center justify-center transition-opacity disabled:opacity-30"
            >
              <ChevronRight className="w-5 h-5" strokeWidth={1.4} />
            </button>

            {/* Dot indicators */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => scrollTo(idx)}
                  aria-label={`Go to image ${idx + 1}`}
                  className={`h-1.5 rounded-full transition-all ${selectedIndex === idx ? 'w-6 bg-[#1a1410]' : 'w-1.5 bg-[#1a1410]/40 hover:bg-[#1a1410]/70'}`}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {!single && (
        <div className="mt-4 grid grid-cols-5 gap-2">
          {images.map((src, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => scrollTo(idx)}
              className={`aspect-square overflow-hidden border transition-opacity ${selectedIndex === idx ? 'border-[#1a1410]' : 'border-[#cdc2b1] hover:opacity-80'}`}
            >
              <img src={src} alt={`thumb ${idx + 1}`} className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGallery;
